import { PocketKnife, ShieldHalf, TruckIcon, Wrench, PackageOpen } from 'lucide-react';
import OutlinedMoldIcon from '../components/icons/OutlinedMoldIcon';
import { MoldOrderFirstLevelType } from '../types/mold';

export enum KanbanColumnStyle {
  DEFAULT = 'Default',
  SMALL_COLUMN = 'SmallColumn',
  SMALL_IMAGE = 'SmallImage',
}

export interface DesignConfiguration {
  kanbanColumnStyle: KanbanColumnStyle;
}

export const designConfiguration: DesignConfiguration = {
  kanbanColumnStyle: KanbanColumnStyle.DEFAULT,
};

const moldAcceptanceStyle = {
  icon: TruckIcon,
  label: 'รับแม่พิมพ์',
  headerBgColor: 'bg-gradient-to-br from-emerald-500 to-teal-600',
  headerTextColor: 'text-white',
  headerBorderColor: 'border-emerald-200',
  headerShadow: 'shadow-lg shadow-emerald-200/50',
}

export const styleConfig = {
  mold_acceptance: moldAcceptanceStyle,
  moldAcceptance: moldAcceptanceStyle,
  insert: {
    icon: Wrench,
    label: 'อินเสิร์ท',
    headerBgColor: 'bg-gradient-to-br from-purple-500 to-indigo-600',
    headerTextColor: 'text-white',
    headerBorderColor: 'border-purple-200',
    headerShadow: 'shadow-lg shadow-purple-200/50',
  },
  part: {
    icon: PocketKnife,
    label: 'ชิ้นส่วน',
    headerBgColor: 'bg-gradient-to-br from-green-500 to-emerald-600',
    headerTextColor: 'text-white',
    headerBorderColor: 'border-green-200',
    headerShadow: 'shadow-lg shadow-green-200/50',
  },
  repair: {
    icon: Wrench,
    label: 'ซ่อมแม่พิมพ์',
    headerBgColor: 'bg-gradient-to-br from-amber-500 to-orange-600',
    headerTextColor: 'text-white',
    headerBorderColor: 'border-amber-200',
    headerShadow: 'shadow-lg shadow-amber-200/50',
  },
  maintenance: {
    icon: ShieldHalf,
    label: 'ล้างแม่พิมพ์',
    headerBgColor: 'bg-gradient-to-br from-blue-500 to-indigo-600',
    headerTextColor: 'text-white',
    headerBorderColor: 'border-blue-200',
    headerShadow: 'shadow-lg shadow-blue-200/50',
  },
  newMold: {
    icon: OutlinedMoldIcon,
    label: 'แม่พิมพ์ใหม่',
    headerBgColor: 'bg-gradient-to-br from-emerald-500 to-teal-600',
    headerTextColor: 'text-white',
    headerBorderColor: 'border-emerald-200',
    headerShadow: 'shadow-lg shadow-emerald-200/50',
  },
  mold_export: {
    icon: PackageOpen,
    label: 'ส่งแม่พิมพ์',
    headerBgColor: 'bg-gradient-to-br from-purple-500 to-violet-600',
    headerTextColor: 'text-white',
    headerBorderColor: 'border-purple-200',
    headerShadow: 'shadow-lg shadow-purple-200/50',
  }

}

export const getHeaderStyleConfig = (moldOrderMainType: MoldOrderFirstLevelType | null) => {
  if (!moldOrderMainType) {
    return {
      headerBgColor: 'bg-gradient-to-br from-gray-500 to-gray-600',
      headerTextColor: 'text-white',
      headerBorderColor: 'border-gray-200',
      headerShadow: 'shadow-lg shadow-gray-200/50',
    };
  }

  switch (moldOrderMainType) {
    case 'repair':
      return styleConfig.repair;
    case 'maintenance':
      return styleConfig.maintenance;
    case 'mold_acceptance':
      return styleConfig.moldAcceptance;
    case 'mold_export':
      return styleConfig.mold_export;
    default:
      return {
        headerBgColor: 'bg-gradient-to-br from-gray-500 to-gray-600',
        headerTextColor: 'text-white',
        headerBorderColor: 'border-gray-200',
        headerShadow: 'shadow-lg shadow-gray-200/50',
      };
  }
};

export const getIconColorForType = (moldOrderMainType: MoldOrderFirstLevelType) => {
  switch (moldOrderMainType) {
    case 'repair':
      return 'text-amber-600';
    case 'maintenance':
      return 'text-blue-600';
    case 'mold_acceptance':
      return 'text-emerald-600';
    case 'mold_export':
      return 'text-purple-600';
    default:
      return 'text-gray-600';
  }
};